export const linuxMintBG1 = require("./linux_mint_bg.png");
export const linuxMintDevices = require("./linuxmint_overlay-fs8.png");
